export {default as imgBackground} from "../assets/images/caat.jpg";